import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function ColorPicker() {
  const [color, setColor] = useState("#ff0000");

  const hexToRgb = (hex) => {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgb(${r}, ${g}, ${b})`;
  };

  const hexToHsl = (hex) => {
    let r = parseInt(hex.slice(1, 3), 16) / 255;
    let g = parseInt(hex.slice(3, 5), 16) / 255;
    let b = parseInt(hex.slice(5, 7), 16) / 255;

    let max = Math.max(r, g, b), min = Math.min(r, g, b);
    let h, s, l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      let d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r: h = (g - b) / d + (g < b ? 6 : 0); break;
        case g: h = (b - r) / d + 2; break;
        case b: h = (r - g) / d + 4; break;
        default: break;
      }
      h /= 6;
    }

    return `hsl(${Math.round(h * 360)}, ${Math.round(s * 100)}%, ${Math.round(l * 100)}%)`;
  };

  const copyToClipboard = (value) => {
    navigator.clipboard.writeText(value);
    alert(`${value} copied!`);
  };

  return (
    <>
      <Helmet>
        <title>Color Picker Tool Online - Get HEX, RGB, HSL Codes Instantly</title>
        <meta
          name="description"
          content="Free online Color Picker tool to select colors and get HEX, RGB, and HSL codes instantly. Perfect for designers, developers, and creatives."
        />
        <meta name="keywords" content="color picker tool, hex code generator, rgb color picker, hsl color code, online color selector, free color tool" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/color-picker" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Color Code Picker</h2>

          <input
            type="color"
            className="form-control form-control-color mb-3"
            value={color}
            onChange={(e) => setColor(e.target.value)}
          />

          <div className="mb-2">
            <strong>HEX:</strong> {color} &nbsp;
            <button className="btn btn-sm btn-outline-primary" onClick={() => copyToClipboard(color)}>Copy</button>
          </div>

          <div className="mb-2">
            <strong>RGB:</strong> {hexToRgb(color)} &nbsp;
            <button className="btn btn-sm btn-outline-primary" onClick={() => copyToClipboard(hexToRgb(color))}>Copy</button>
          </div>

          <div className="mb-2">
            <strong>HSL:</strong> {hexToHsl(color)} &nbsp;
            <button className="btn btn-sm btn-outline-primary" onClick={() => copyToClipboard(hexToHsl(color))}>Copy</button>
          </div>

          <div
            className="mt-4 p-3"
            style={{
              backgroundColor: color,
              color: "#fff",
              textAlign: "center",
              fontWeight: "bold",
              borderRadius: "8px"
            }}
          >
            Sample Color Preview
          </div>
        </div>
      </section>
    </>
  );
}
